import { EmailTemplateSystemSlug } from '../enums';
import type {
	InvoiceDetailEmailTemplateDataInterface,
	OrderDetailEmailTemplateDataInterface,
} from '../models';

export const DefaultEmailTemplateData = {
	[EmailTemplateSystemSlug.ORDER_DETAIL]: {
		CART: {
			hideTopRightHeader: true,
			hidePaymentFields: true,
			hideShippingFields: true,
			footerMessage: 'Thank you for your business.',
		} as Partial<OrderDetailEmailTemplateDataInterface>,
		ORDER: {
			footerMessage: 'Thank you for your business.',
		} as Partial<OrderDetailEmailTemplateDataInterface>,
		QUOTE: {
			hidePaymentFields: true,
			hideShippingFields: true,
			footerMessage:
				'Please reach out to your salesperson when you are ready to place an order.',
		} as Partial<OrderDetailEmailTemplateDataInterface>,
	},
	[EmailTemplateSystemSlug.INVOICE_DETAIL]: {
		footerMessage: 'Your invoice is attached. Thank you for your business.',
	} as Partial<InvoiceDetailEmailTemplateDataInterface>,
};

/**
 * PD-15079 — the footer for a credit memo sent through the invoice template.
 * Both document types share EmailTemplateSystemSlug.INVOICE_DETAIL, so this
 * lives beside the slug-keyed defaults rather than inside them; the backend
 * substitutes it (and the compose modal defaults to it) when the document is
 * a credit memo.
 */
export const CREDIT_MEMO_EMAIL_FOOTER_MESSAGE =
	'Your credit memo is attached. Thank you for your business.';
